export default "__VITE_ASSET__Bl$dBFW6__"